import classNames from "classnames";
import { uniqueId } from "lodash";
import { JSX } from "react";
import SharedUsers from "@app/reports/SharedUsers";
import { RouteMatchParams } from "../models";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";

interface GenerateBodyProps extends RouteMatchParams {
  emailOnSuccess: boolean;
  isLoading: boolean;
  onEmailOnSuccessChange: (emailOnSuccess: boolean) => void;
  onGenerateClick: () => Promise<void>;
  onReportNameChange: (reportName: string) => void;
  onSharedUsersChange: (users: number[]) => void;
  reportName: string;
  sharedUsers: number[];
}

const GenerateBody = (props: GenerateBodyProps): JSX.Element => {
  const isFileNameOk = props.reportName && props.reportName.length > 0 && props.reportName.length < 255;
  const hasError = !isFileNameOk;
  const emailId = uniqueId("email-me");

  return (
    <>
      <hr />
          <div className="row">
            <div className="col-12 ps-3">
              <div className={classNames("d-inline-flex align-items-center", { "has-error": hasError })}>
                <QESTextInput
                  className=""
                  testId={`search-checkbox-dropdown__report-name-input`}
                  label="Report Name:"
                  value={props.reportName}
                  onChange={(e) => props.onReportNameChange(e.target.value)}
                  containerClassName="checkbox-dropdown__label ps-0"
                />

                {isFileNameOk ? (
                  <>
                    <SharedUsers
                      exportType={"NetworkIntegrityProvidersReport"}
                      customProjectIds={[Number.parseInt(props.projectId)]}
                      tooltipTitle="Users in this list have been filtered to only show users with access to this project and information in this report"
                      updateSelectedSharedUsers={props.onSharedUsersChange}
                      sharedUsersFilter={props.sharedUsers}
                    />
                    <QESCheckbox
                      containerClassName="ms-2 mt-4 demibold"
                      label={<>
                        <i className="fa fa-envelope me-2" />
                        Yes, please email me {(!props.sharedUsers || props.sharedUsers?.length === 0) ? "" : `and the other user${props.sharedUsers?.length > 1 ? "s" : ""}`} a link to the report when ready.
                      </>}
                      id={emailId}
                      className="me-2"
                      checked={props.emailOnSuccess}
                      onChange={(e) => props.onEmailOnSuccessChange(e.target.checked)}
                      testId="generate-body__email-on-success"
                    />
                  </>
                ) : (
                  <label className="ms-2 text-danger"> Invalid report name, please enter a name between 1 and 255 characters.</label>
                )}
              </div>
              <div className="form-row align-items-center mt-3">
                <div className="col-12">
                  {props.isLoading ? (
                    <QESButton qesTestId="generate-body_generating" qesType="primary" disabled className="me-2"><i className="fa fa-spinner fa-spin" /> Generating...</QESButton>
                  ) : (
                    <QESButton
                      qesTestId="generate-body_generate"
                      qesType="primary"
                      disabled={!isFileNameOk}
                      className="me-2"
                      onClick={props.onGenerateClick}
                    >Generate</QESButton>
                  )}
                </div>
              </div>
            </div>
          </div>
    </>
  );
}

export { GenerateBody };